export default __webpack_public_path__ + "static/media/truly-inbox.d8f0ea80.svg";